import PropTypes from 'prop-types';
import React from 'react';

export class GroupListItem extends React.Component {
  render() {
    let itemClass = 'list-group-item';
    itemClass += this.props.understated ? ' understated' : '';

    const buttonClass = (this.props.selected ? ' active' : '');

    const indicatorCss = 'fa fa-circle' + (this.props.isNew ? '' : ' hidden');

    return (
      <li className={ itemClass } key={ this.props.index }>
        <a
          role="button"
          className={ buttonClass }
          onClick={ this.props.clickHandler }
        >
          <span className="fa-solid fa-chevron-right chevron d-lg-none"></span>
          <span className={ indicatorCss }></span>
          <span className="primary-text">{this.props.title}</span>
        </a>
      </li>
    );
  }
}

GroupListItem.propTypes = {
  isNew: PropTypes.bool,
  title: PropTypes.string,
  understated: PropTypes.bool,
  index: PropTypes.number,
  selected: PropTypes.bool,
  clickHandler: PropTypes.func,
};
